<template>
    <v-main class="main-content" style="overflow-x: hidden;">
        <div class="tpl-snow">
            <section v-for="(item, index) in getNItems(40)" :key="index"></section>
        </div>
        <div class="content-1">
            <div>
                <div class="content-img slide-t my-8">
                    <img src="@/assets/images/img-redimibles/title-top.png" class="img-top">
                </div>
                <div class="content-img">
                    <v-card outlined color="transparent" class="card-principal">
                        <v-row class="">
                            <v-col cols="6" sm="6" md="4" lg="3" xl="3" v-for="(item, i) in cards" :key="i"
                                :class="{ [item.className]: true }">
                                <v-card outlined :href="item.url" target="_blank" class="card-img card-secundario">
                                    <div class="d-flex flex-no-wrap ">
                                        <div style="" class="d-flex justify-center align-center seccion-product-img">
                                            <img class="product-img"
                                                :src="require('@/assets/images/img-redimibles/' + item.id + '-img.png')" />
                                        </div>
                                        <div class="seccion-des-img">
                                            <img class="des-img" style=""
                                                :src="require('@/assets/images/img-redimibles/' + item.id + '-des.png')" />
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
                <div class="content-img slide-b mt-6">
                    <img class="img-bottom" src="@/assets/images/img-redimibles/title-bottom.png" style="">
                </div>
                <div class="content-img slide-b py-3">
                    <img src="@/assets/images/img-redimibles/logo-se.png" style="">
                </div>
            </div>
        </div>
    </v-main>
</template>
<script>

export default {
    components: {
    },
    data: () => ({
        cards: [{ id: '01', className: 'card-l', url: 'https://wa.link/za5ev9' },
        { id: '02', className: 'card-t', url: 'https://wa.link/ji3qto' },
        { id: '03', className: 'card-r', url: 'https://wa.link/7o76in' },
        { id: '04', className: 'card-b', url: 'https://wa.link/waxiv5' },
        { id: '05', className: 'card-l', url: 'https://wa.link/13qct2' },
        { id: '06', className: 'card-t', url: 'https://wa.link/nk3ozs' },
        { id: '07', className: 'card-r', url: 'https://wa.link/0meczb' },
        { id: '08', className: 'card-b', url: 'https://wa.link/dmt9mi' },
        { id: '09', className: 'card-l', url: 'https://wa.link/3koq4x' },
        { id: '10', className: 'card-t', url: 'https://wa.link/8gtouk' },
        { id: '11', className: 'card-r', url: 'https://wa.link/3dggre' },],
    }),

    methods: {
        getNItems(count) {
            return new Array(count).fill(null);
        }
    },
}

</script>
<style scoped>
@import '@/assets/styles/styles-banners/style-banners.css';
</style>